import { HStack, Text, Tooltip } from '@chakra-ui/react';
import ChartingIcon from '@public/images/charting.gif';
import { Toast } from '@web-app/components/Toast';
import Image from 'next/image';
import React from 'react';

export const ChartingTag = () => (
  <Tooltip
    background="none"
    label={
      <Toast
        withArrow
        title="Recording active"
        text="All good here! Your notes will be generated after the session."
      />
    }
  >
    <HStack color="white" padding="4px" borderRadius="6px">
      <Image src={ChartingIcon} alt="Charting" width={24} />

      <Text fontSize="12px" fontWeight="500" pr="8px">
        Charting
      </Text>
    </HStack>
  </Tooltip>
);
